export default "__VITE_ASSET__bd34be01__"